"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Item = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "Item",
  class: "pl-irbcbb0",
  vars: {
    "irbcbb0-0": [({
      order
    }) => order],
    "irbcbb0-1": [({
      hide
    }) => hide ? 'hidden' : 'visible'],
    "irbcbb0-6": [({
      hide
    }) => hide ? 'hidden' : 'visible'],
    "irbcbb0-7": [({
      partial
    }) => partial === 'dark1' ? _intents.default.ux.boxHighContrast.foregroundColor : _intents.default.ux.box.foregroundColor]
  }
});
const IconChevronDown = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconChevronDown",
  class: "pl-i1kijuc2"
});
const ItemTrigger = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ItemTrigger",
  class: "pl-i1r8rccv",
  vars: {
    "i1r8rccv-0": [({
      isMoreButton
    }) => isMoreButton ? '0 0.5rem' : '0']
  }
});

/**
 * DesktopMenuItem - Desktop Menu Item Container Component
 *
 * A wrapper component that serves as a container for desktop navigation menu items.
 * This component handles the structural aspects of desktop navigation items including:
 * - Layout positioning and ordering
 * - Hover/focus state management
 * - Dropdown container functionality
 * - Visual styling (background colors, borders, etc.)
 *
 * @param {Object} props React props
 * @param {string} props._name Navigation item tracking name for analytics
 * @param {string} [props.dataCy='nav-item'] Cypress test identifier
 * @param {number} props.order The display order of the navigation item (used for CSS order)
 * @param {string} [props.partial] Theme partial identifier for dark theme styling
 * @param {boolean} [props.hide] Whether to hide the item (used for overflow management)
 * @param {React.ReactNode} props.itemText The display text or component for the navigation item
 * @param {React.ReactNode} [props.children] Optional dropdown content (DesktopNavLinks, etc.)
 * @returns {React.ReactElement} DesktopMenuItem container component
 * @public
 */

const DesktopMenuItem = /*#__PURE__*/(0, _react.forwardRef)(({
  _name,
  dataCy = 'nav-item',
  order,
  partial,
  hide,
  itemText,
  children,
  ...rest
}, ref) => {
  const itemTextRef = (0, _react.useRef)(null);
  _patternLibraryUtils.tracking.useTracking(itemTextRef);
  const trackingProps = _patternLibraryUtils.tracking.props(_name, true, false);
  const isMoreButtonOrHasDropdown = () => {
    return dataCy === 'moreMenu' || !!children;
  };
  return /*#__PURE__*/_react.default.createElement(Item, (0, _extends2.default)({
    className: `desktop-menu-item${dataCy === 'moreMenu' ? ' desktop-menu-item--more' : ''}`,
    "data-cy": dataCy,
    ref: ref,
    hide: hide,
    partial: partial,
    order: order ?? 'unset',
    "aria-haspopup": !!children
  }, rest), /*#__PURE__*/_react.default.createElement(ItemTrigger, (0, _extends2.default)({
    className: "desktop-menu-item__text",
    "data-cy": "item-text",
    ref: itemTextRef,
    isMoreButton: isMoreButtonOrHasDropdown()
  }, trackingProps), itemText, children && /*#__PURE__*/_react.default.createElement(IconChevronDown, {
    "data-cy": "down-chevron",
    className: "more-chevron desktop-menu-item__chevron"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down"
  }))), children);
});
DesktopMenuItem.displayName = 'DesktopMenuItem';
DesktopMenuItem.propTypes = {
  _name: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  itemText: _propTypes.default.node,
  order: _propTypes.default.number,
  partial: _propTypes.default.string,
  hide: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = exports.default = DesktopMenuItem;